export default __webpack_public_path__ + "static/media/UTaustinlogo.f42ebc26.png";